/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoNftDisassembleLogListNftDisassembleLogListData model module.
 * @module model/LogControllerDtoNftDisassembleLogListNftDisassembleLogListData
 * @version 1.0
 */
class LogControllerDtoNftDisassembleLogListNftDisassembleLogListData {
    /**
     * Constructs a new <code>LogControllerDtoNftDisassembleLogListNftDisassembleLogListData</code>.
     * @alias module:model/LogControllerDtoNftDisassembleLogListNftDisassembleLogListData
     */
    constructor() { 
        
        LogControllerDtoNftDisassembleLogListNftDisassembleLogListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoNftDisassembleLogListNftDisassembleLogListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoNftDisassembleLogListNftDisassembleLogListData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoNftDisassembleLogListNftDisassembleLogListData} The populated <code>LogControllerDtoNftDisassembleLogListNftDisassembleLogListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoNftDisassembleLogListNftDisassembleLogListData();

            if (data.hasOwnProperty('disassembleNo')) {
                obj['disassembleNo'] = ApiClient.convertToType(data['disassembleNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('nftGrade')) {
                obj['nftGrade'] = ApiClient.convertToType(data['nftGrade'], 'Number');
            }
            if (data.hasOwnProperty('nftType')) {
                obj['nftType'] = ApiClient.convertToType(data['nftType'], 'Number');
            }
            if (data.hasOwnProperty('nftLevel')) {
                obj['nftLevel'] = ApiClient.convertToType(data['nftLevel'], 'Number');
            }
            if (data.hasOwnProperty('nftSeal')) {
                obj['nftSeal'] = ApiClient.convertToType(data['nftSeal'], 'String');
            }
            if (data.hasOwnProperty('walletTransactionNo')) {
                obj['walletTransactionNo'] = ApiClient.convertToType(data['walletTransactionNo'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoNftDisassembleLogListNftDisassembleLogListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoNftDisassembleLogListNftDisassembleLogListData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['nftSeal'] && !(typeof data['nftSeal'] === 'string' || data['nftSeal'] instanceof String)) {
            throw new Error("Expected the field `nftSeal` to be a primitive type in the JSON string but got " + data['nftSeal']);
        }

        return true;
    }


}



/**
 * @member {Number} disassembleNo
 */
LogControllerDtoNftDisassembleLogListNftDisassembleLogListData.prototype['disassembleNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoNftDisassembleLogListNftDisassembleLogListData.prototype['accountNo'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoNftDisassembleLogListNftDisassembleLogListData.prototype['nftUid'] = undefined;

/**
 * @member {Number} nftGrade
 */
LogControllerDtoNftDisassembleLogListNftDisassembleLogListData.prototype['nftGrade'] = undefined;

/**
 * @member {Number} nftType
 */
LogControllerDtoNftDisassembleLogListNftDisassembleLogListData.prototype['nftType'] = undefined;

/**
 * @member {Number} nftLevel
 */
LogControllerDtoNftDisassembleLogListNftDisassembleLogListData.prototype['nftLevel'] = undefined;

/**
 * @member {String} nftSeal
 */
LogControllerDtoNftDisassembleLogListNftDisassembleLogListData.prototype['nftSeal'] = undefined;

/**
 * @member {Number} walletTransactionNo
 */
LogControllerDtoNftDisassembleLogListNftDisassembleLogListData.prototype['walletTransactionNo'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoNftDisassembleLogListNftDisassembleLogListData.prototype['createdAt'] = undefined;






export default LogControllerDtoNftDisassembleLogListNftDisassembleLogListData;

